import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0edea9c4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "scrolled" };
const _hoisted_2 = { class: "download" };
const _hoisted_3 = ["href", "title"];
import POLICIES, { RAW_POLICIES_PATHS_MAP } from '@/lib/policies';
import MarkdownFormatted from '@/components/MarkdownFormatted.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LegalStuff',
    props: {
        policyName: null
    },
    setup(__props) {
        const props = __props;
        const policy = POLICIES[props.policyName];
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("a", {
                        href: _unref(RAW_POLICIES_PATHS_MAP)[props.policyName],
                        title: `Download our ${__props.policyName.split('-').join(' ')}`,
                        download: ""
                    }, [
                        _createTextVNode(_toDisplayString(__props.policyName) + " ", 1),
                        _createVNode(_component_v_icon, { name: "fa-download" })
                    ], 8, _hoisted_3)
                ]),
                _createVNode(MarkdownFormatted, {
                    source: _unref(policy).fileContent
                }, null, 8, ["source"])
            ]));
        };
    }
});
